import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import LandingPage from "./componests/landingpage/LandingPage";
import OrganizationRegister from "./componests/OrganizationRegister";
import ErrorPage from "./error-page";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import AdminDashboard from "./componests/Dashboard/AdminDashboard";
import StudentDetail from "./componests/Dashboard/StudentDetail";
import Login from "./componests/Dashboard/Login";
import  Dashboard from './componests/studentDashboard/Dashboard'
import {
  QueryClient,
  QueryClientProvider,
} from "react-query";
import StudentLogin from "./componests/studentDashboard/StudentLogin";
import Team from "./componests/Team";
;
const queryClient = new QueryClient();

const router = createBrowserRouter([
  {
    path: "/",
    element: <LandingPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/feefix/registerOrganization",
    element: <OrganizationRegister />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/feefix/login",
    element: <Login />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/manageedu/admin",
    element: <AdminDashboard />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/manageedu/admin/feeeasy/student/:id",
    element: <StudentDetail /> ,
  },
  {
    path: "/manageedu/dashboard/student",
    element: <Dashboard /> ,
  },
  {
    path:"/manageedu/student/login",
    element: <StudentLogin />,
  },
  {
    path:"/manageedu/team",
    element: <Team/>,
  }

]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
     
      <RouterProvider router={router} />
    
    </QueryClientProvider>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
reportWebVitals(console.log);
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
